import React, { memo, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import AuthScreenLayout from 'modules/views/shared/AuthScreenLayout';

import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { useStyles } from './styles';
import { useQueryParamState } from 'utils/useQueryParamState';
import { GeneralModel } from 'modules/models';
import Loader from 'modules/views/shared/Loader';

export interface IValidateUserProps {
  validateUserResult: any;
  validateUserLoading: GeneralModel.ILoadingStatus;
  validateUser: (token: string) => void;
}

export interface IQueryParams {
  token: string;
}

const ValidateUser = ({ validateUserResult, validateUserLoading, validateUser }: IValidateUserProps) => {
  const location = useLocation();
  const classes = useStyles();

  const [queryParams, setQueryParams] = useQueryParamState<IQueryParams>({
    token: '',
  });

  useEffect(() => {
    console.log('Token: ', queryParams.token);
    validateUser(queryParams.token);
  }, []);

  return (
    <>
      <AuthScreenLayout
        formContainerStyleClass={classes.formContainerStyleClass}
        titleStyleClass={classes.titleStyleClass}
        title={
          validateUserLoading && !validateUserLoading.isLoading && validateUserLoading.hasError && validateUserLoading.error
            ? validateUserLoading.error
            : validateUserResult && validateUserResult.contactValue
            ? `The ${validateUserResult.contactType === 0 ? 'email address' : 'phone number'} ${validateUserResult.contactValue} has been verified!`
            : 'Verifying...'
        }
        // subtitle={selectedOption === 'email' ? 'Check your Inbox.' : ''}
        renderContent={() =>
          validateUserResult &&
          validateUserResult.contactValue && (
            <div className={classes.validateUserBtnWrapper}>
              <Link className={classes.validateUserBtn} data-testid="go-to-login-btn" to="/">
                <Button color="primary" variant="contained" fullWidth={true} size="large" type="submit">
                  Go to Login
                </Button>
              </Link>
            </div>
          )
        }
      />
      {validateUserLoading && validateUserLoading.isLoading && <Loader />}
    </>
  );
};

export default memo(ValidateUser);
